/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
let serviceRootUrl = window.location.href.toLowerCase().includes("localhost")
	? "https://apis-sandbox.intel.com/sc/tms/tender/v1/tender-dataset"
	: window.location.href.toLowerCase().includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
	? "https://apis-stage.intel.com/sc/tms/tender/v1/tender-dataset"
	: window.location.href.toLowerCase().includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
	? "https://apis-sandbox.intel.com/sc/tms/tender/v1/tender-dataset"
	: window.location.href.toLowerCase().includes("https://transportationcons.intel.com") ||
      window.location.href.toLowerCase().includes("https://tmspreprod-portal.intel.com") ||
      window.location.href.toLowerCase().includes("https://transportation-preprod.intel.com")
	? "https://apis-sandbox.intel.com/sc/tms/tender/v1/tender-dataset"
    : window.location.href.toLowerCase().includes("https://transportation.intel.com") ||
      window.location.href.toLowerCase().includes("https://tms-portal.intel.com")
	? "https://apis.intel.com/sc/tms/tender/v1/tender-dataset"
	: "";

let getRedirectUrl = window.location.href.toLowerCase().includes("localhost")
  ? "http://localhost:3000"
  : window.location.href
      .toLowerCase()
      .includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
  ? "https://ncrmdev.apps1-fm-int.icloud.intel.com"
  : window.location.href
      .toLowerCase()
      .includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
  ? "https://tmsconsint.apps1-fm-int.icloud.intel.com"
  : window.location.href
      .toLowerCase()
      .includes("https://transportationcons.intel.com")
  ? "https://transportationcons.intel.com"
   : window.location.href
      .toLowerCase()
      .includes("https://tmspreprod-portal.intel.com")
  ? "https://tmspreprod-portal.intel.com"
  : window.location.href
      .toLowerCase()
      .includes("https://transportation-preprod.intel.com")
  ? "https://transportation-preprod.intel.com"
  
  : window.location.href
      .toLowerCase()
      .includes("https://transportation.intel.com")
  ? "https://transportation.intel.com"
   : window.location.href
      .toLowerCase()
      .includes("https://tms-portal.intel.com")
  ? "https://tms-portal.intel.com"
  : "";

  let getClientID = window.location.href.toLowerCase().includes("localhost")
? "e6d8466b-35fb-4ddb-98b0-c8b6704f3e65"
: window.location.href.toLowerCase().includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
? "e68b761c-68cd-4a04-9cb6-1ffe5970a4ce"
: window.location.href.toLowerCase().includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
? "e6d8466b-35fb-4ddb-98b0-c8b6704f3e65"
: window.location.href.toLowerCase().includes("https://transportationcons.intel.com") ||
  window.location.href.toLowerCase().includes("https://tmspreprod-portal.intel.com") ||
  window.location.href.toLowerCase().includes("https://transportation-preprod.intel.com")
? "e6d8466b-35fb-4ddb-98b0-c8b6704f3e65"
: window.location.href.toLowerCase().includes("https://transportation.intel.com") ||
  window.location.href.toLowerCase().includes("https://tms-portal.intel.com")
? "f94922bc-71c7-4efd-a0f1-81a1c21e945b"
: "";

let getAuthority = window.location.href.toLowerCase().includes("localhost")
? "https://login.microsoftonline.com/24d2eec2-c04e-4c44-830d-f374a7b9559e/v2.0/"
: window.location.href.toLowerCase().includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
? "https://login.microsoftonline.com/9889e411-4383-4500-8c2a-e8f095438f4f/v2.0/"
: window.location.href.toLowerCase().includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
? "https://login.microsoftonline.com/24d2eec2-c04e-4c44-830d-f374a7b9559e/v2.0/"
: window.location.href.toLowerCase().includes("https://transportationcons.intel.com") ||
  window.location.href.toLowerCase().includes("https://tmspreprod-portal.intel.com") ||
  window.location.href.toLowerCase().includes("https://transportation-preprod.intel.com")
? "https://login.microsoftonline.com/24d2eec2-c04e-4c44-830d-f374a7b9559e/v2.0/"
: window.location.href.toLowerCase().includes("https://transportation.intel.com") ||
  window.location.href.toLowerCase().includes("https://tms-portal.intel.com")
? "https://login.microsoftonline.com/46c98d88-e344-4ed4-8496-4ed7712e255d/v2.0/"
: "";

let getScope = window.location.href.toLowerCase().includes("localhost")
? "api://e6d8466b-35fb-4ddb-98b0-c8b6704f3e65/SPS_NCRM_App"
: window.location.href.toLowerCase().includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
? "api://e68b761c-68cd-4a04-9cb6-1ffe5970a4ce/SPS_TMS_App"
: window.location.href.toLowerCase().includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
? "api://e6d8466b-35fb-4ddb-98b0-c8b6704f3e65/SPS_NCRM_App"
: window.location.href.toLowerCase().includes("https://transportationcons.intel.com") ||
  window.location.href.toLowerCase().includes("https://tmspreprod-portal.intel.com") ||
  window.location.href.toLowerCase().includes("https://transportation-preprod.intel.com")
? "api://e6d8466b-35fb-4ddb-98b0-c8b6704f3e65/SPS_NCRM_App"
: window.location.href.toLowerCase().includes("https://transportation.intel.com") ||
  window.location.href.toLowerCase().includes("https://tms-portal.intel.com")
? "api://f94922bc-71c7-4efd-a0f1-81a1c21e945b/SPS_NCRM_Intel_Internal_Azure"
: "";

export const msalConfig = {
    auth: {
        clientId: getClientID,
        authority: getAuthority,
        redirectUri: getRedirectUrl,
        knownAuthorities: ["login.microsoftonline.com","apis.intel.com"],
        protocolMode: "OIDC",
        // redirectUri: "https://ncrmdev.apps1-fm-int.icloud.intel.com",

        scopes: [getScope],
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [getScope],
    // scopes: ["api://3c4e326a-cea5-4c5b-b8df-b0cf65791264/SAP-Y_APG_TMS_G0-AZAD"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const sapConfig = {
    sapEndpoint: serviceRootUrl
};
